<template>
  <div class="rb-stock-status-description" v-if="description">
    <span class="rb-dash" v-if="useDash">&nbsp;-&nbsp;</span>{{ description }}
  </div>
</template>
<script>
/**
 * Displays Stock Status Description metafield per variant if available
 *
 * @props
 * useDash: Boolean
 *
 * @implements
 * CommMixin
 *
 * @listens
 * rb-variant-change
 */
import CommMixin from "@/mixins/CommMixin";
export default {
  mixins: [CommMixin],
  props: {
    useDash: {
      type: Boolean,
      default: false,
    },
    shippingText: {
      type: String,
      default: "",
    }
  },
  mounted: function () {
    this.subscribe("rb-variant-change", this.onVariantChange);
  },
  data: function () {
    return {
      currentVariant: null,
    };
  },
  computed: {
    description: function () {
      if (
        this.currentVariant &&
        this.currentVariant.metafields_custom &&
        this.currentVariant.metafields_custom.stock_status_description
      ) {
        return this.currentVariant.metafields_custom.stock_status_description + " " + this.shippingText;
      }
      return "";
    },
  },
  methods: {
    onVariantChange: function (variant) {
      this.currentVariant = variant;
    },
  },
};
</script>
